module.exports = __webpack_public_path__ + "static/media/cadmasters.7a6840e7.jpg";